import { RegistrationActionTypes } from './types'

export const RESET_STORE = 'REGISTRATION/RESET_STORE'

export const resetRegistrationStore = (): RegistrationActionTypes => {
  return { type: RESET_STORE }
}
